import React from 'react'
import { connect } from 'react-redux'
import LoadingIndicator from '../components/LoadingIndicator'
import compose from 'recompose/compose'

const mapStateToProps = state => ({
    isStalling: state.getIn(['tour', 'mainMedia', 'stalling']),
})

const shouldRenderLoadingIndicator = WrappedComponent => ({ isStalling, ...props }) =>
    isStalling ? <WrappedComponent {...props} /> : null

export default compose(
    connect(mapStateToProps),
    shouldRenderLoadingIndicator
)(LoadingIndicator)
